<template>
	<el-form v-if="form" label-position="top">

		<el-form-item label="id">
			<el-input v-model="form.id" disabled></el-input>
		</el-form-item>


		<el-form-item label="role">
			<div class="f fx fcc cml-1">
				<el-input v-model="form.roleId" disabled></el-input>
				<el-input v-model="form.roleName" disabled></el-input>
				<el-button @click="selectRole">select</el-button>
			</div>
		</el-form-item>


		<el-form-item label="robot code">
			<el-input v-model="form.robotCode"></el-input>
		</el-form-item>

		<el-form-item>
			<el-button type="primary" @click="submit">ok</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {},
		data() {
			return {
				form: {},
			}
		},
		mounted() {
			this.form = {
				...this.propForm
			};
		},
		methods: {

			close() {
				this.$emit('close');
			},
			submit() {
				if (this.form.id) {
					request({
						url: '/api/robot/updateRobot',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				} else {
					request({
						url: '/api/robot/createRobot',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				}
			},

			selectRole() {
				dialogs.open('RoleTable', {
					mode: 'select',
					select: role => {
						this.form.roleId = role.id;
						this.form.roleName = role.name;
						this.$forceUpdate()
					}
				})
			}

		}
	}
</script>

<style>

</style>